// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2485":"c1c41e69","2803":"915d3126","3693":"83774bae","8419":"225d461a","9232":"83774bae","9631":"24d93239"}[chunkId] + ".chunk.css";
};